import React from 'react';

// Small, centered confirm dialog for reversible-feeling destructive actions
// (e.g. deleting one log entry) — the "light" counterpart to a heavier,
// two-step flow like ArchiveChoreSheet. Red only shows up in the confirm button.
const ConfirmDialog = ({ title, message, impact, confirmLabel = 'Delete', cancelLabel = 'Keep it', onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-ink-overlay/70 backdrop-blur-sm z-[60] flex items-center justify-center p-5 animate-in fade-in duration-200" onClick={onCancel}>
      <div
        className="bg-ink-card2 border border-white/10 rounded-3xl p-6 w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-serif text-ink-fg">{title}</h2>
        {message && <p className="text-sm text-ink-fg/60 mt-3">{message}</p>}
        {impact && (
          <div className="flex items-center gap-3 mt-4 p-3 rounded-2xl bg-ink-card3 border border-white/10">
            {impact}
          </div>
        )}
        <div className="flex gap-2.5 mt-5">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 h-12 rounded-2xl border border-white/15 text-ink-fg font-semibold text-sm hover:bg-ink-card3 transition-colors"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 h-12 rounded-2xl bg-danger text-ink-shell font-semibold text-sm hover:brightness-95 transition-all active:scale-95"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
